module.exports = __webpack_public_path__ + "static/media/74.26faf2f9.png";